import React from "react";
import "typeface-roboto";
import { Route, Switch, Redirect } from "react-router-dom";
import DocEditor from "./containers/DocEditor";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import PrivateRoute from "./PrivateRoute";
import Login from "./Login";
import Drafts from "./Drafts";
import Manuals from "./Manuals";
import SearchResults from "./SearchResults";
import GroupedMenu from "./GroupedMenu";
import SupportSearch from "./SupportSearch";

const theme = createMuiTheme({
  palette: {
    primary: {
      light: "#9876ba",
      main: "#694a8a",
      dark: "#3c215c",
      contrastText: "#fff"
    },
    secondary: {
      light: "#f8fdff",
      main: "#9b90bd",
      dark: "#9a90bb69",
      purpleLight:"#9c91bf57",
      contrastText: "#000",
      gray: "#615c5c"
    }
  },
  typography: {
    useNextVariants: true,
  }
});

const App = () => {
  // PLEASE update the PathToName.js file when you add/modify a route
  return (
    <BrowserRouter>
      <MuiThemeProvider theme={theme}>
          <ErrorBoundary>
            <Switch>
              <PrivateRoute path="/" exact component={GroupedMenu} menu="Inbox"  title="Recibidos" />
              <PrivateRoute path="/oficios/:id?" component={DocEditor} title="Oficio" />
              <PrivateRoute path="/recibidos/:tab?/:page?" component={GroupedMenu} menu="Inbox"  title="Recibidos" />
              <PrivateRoute path="/borradores/:tab?/:page?" component={Drafts} title="Borradores"/>
              <PrivateRoute path="/enviados/:tab?/:page?" component={GroupedMenu} menu="Sent" title="Enviados" />
              <PrivateRoute path="/configuraciones" component={GroupedMenu} menu="Settings" title="Configuraciones"/>
              <PrivateRoute path="/busqueda" component={SearchResults} title="Búsqueda"/>
              <PrivateRoute path="/manuales" component={Manuals} title="Manuales"/>
              <PrivateRoute path="/soporte" component={SupportSearch} title="Soporte"/>
              <Route path='/login' component={Login} />
              <Redirect from="*" to='/login' />
            </Switch>
          </ErrorBoundary>
      </MuiThemeProvider>
    </BrowserRouter>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js